import { render, staticRenderFns } from "./ChangePasswordForm.vue?vue&type=template&id=706e0841&scoped=true&"
import script from "./ChangePasswordForm.vue?vue&type=script&lang=ts&"
export * from "./ChangePasswordForm.vue?vue&type=script&lang=ts&"
import style0 from "./change-password-form.scss?vue&type=style&index=0&id=706e0841&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706e0841",
  null
  
)

export default component.exports